export default class AWSAccountSubnet {
	aZ1_CIDR: string;

	aZ2_CIDR?: string;

	aZ3_CIDR?: string;

	name: string;

	uniqueRouteTablePerAz: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.aZ1_CIDR = obj.aZ1_CIDR?.prefix + '/' + obj.aZ1_CIDR?.mask;

		this.aZ2_CIDR = obj.aZ2_CIDR
			? `${obj.aZ2_CIDR?.prefix}/${obj.aZ2_CIDR?.mask}`
			: '';

		this.aZ3_CIDR = obj.aZ3_CIDR
			? `${obj.aZ3_CIDR?.prefix}/${obj.aZ3_CIDR?.mask}`
			: '';
	}
}
